import { CustomerList } from '@/features';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/customers/')({
  component: RouteComponent,
  staticData: {
    icon: 'Contact',
    title: 'Customers',
  },
});

function RouteComponent() {
  return <CustomerList />;
}
